// Centralized styles for glossary data components

// Common text and color styles
export const styles = {
  cells: {
    fontSize: "12px",
    color: "#667085",
    fontFamily: "Poppins",
  },
  success: {
    color: "#5EC360",
  },
  warning: {
    color: "#F3BE34",
  },
  error: {
    color: "#D04444",
  },
};

// Common sx styles for MUI components
export const sxStyles = {
  circleIcon: {
    fontSize: "0.5rem",
    position: "relative",
    top: "5px",
    marginRight: "5px",
  },
  listItemIcon: {
    minWidth: "auto",
  },
};

// Common inline style for icons
export const iconStyle = {
  color: "#667085",
  fontSize: "inherit",
};
